import { usePartnerResourceString, usePartnerResourceStrings } from "@gamedev-web/gamedev-sdk-core";

import { PartnerId } from "../constants";

export const useString = (key: string, ...args: string[]): string => {
  const localizedString = usePartnerResourceString(key, PartnerId, ...args);
  return key ? localizedString : "";
};

export const useStrings = (...keys: string[]): string[] =>
  usePartnerResourceStrings(PartnerId, ...keys);
